import type { Theme } from "@mui/material";
import { blue } from "@mui/material/colors";
import { FILE_EXTENSIONS } from "../Constants";
import type { TYPE_FILE_EXTENSIONS } from "Common/Types";

export const getFileIconColor = (extension: TYPE_FILE_EXTENSIONS | null, theme: Theme) => {
  switch (extension?.toLowerCase()) {
    case FILE_EXTENSIONS.PDF:
      return theme.palette.secondary.main;
    case FILE_EXTENSIONS.JPG:
    case FILE_EXTENSIONS.JPEG:
    case FILE_EXTENSIONS.PNG:
      return blue[400];
    case "folder":
      return theme.palette.primary.main;
    default:
      return theme.palette.grey[800];
  }
};
